// 农业模块图标资源
// 使用 require 让 webpack 解析资源路径，避免运行时找不到资源
const iconNongye = {
    'icon-ny-1': require('./icon-ny-1.svg'),
    'icon-ny-2': require('./icon-ny-2.svg'),
    'icon-ny-3': require('./icon-ny-3.svg'),
    'icon-ny-4': require('./icon-ny-4.svg'),
    'icon-ny-5': require('./icon-ny-5.svg'),
    'icon-ny-6': require('./icon-ny-6.svg'),
    'icon-plant-1': require('./icon-plant-1.svg'),
    'icon-plant-2': require('./icon-plant-2.svg'),
    'icon-plant-3': require('./icon-plant-3.svg'),
    'icon-plant-4': require('./icon-plant-4.svg'),
};

export default iconNongye;
